var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServicesNav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40.0026,
    height: 40.0026,
    rx: 10.6663,
    fill: "#E9ECEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.0402,
    y: 15.6631,
    width: 20.2428,
    height: 13.4952,
    rx: 2.24919,
    stroke: "black",
    strokeWidth: 1.6869
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6632 13.4142C15.6632 12.172 16.6702 11.165 17.9124 11.165H22.4108C23.653 11.165 24.66 12.172 24.66 13.4142V15.6634H15.6632V13.4142Z",
    stroke: "black",
    strokeWidth: 1.6869
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0402 21.2861H30.2829",
    stroke: "black",
    strokeWidth: 1.6869
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesNav);
export default __webpack_public_path__ + "static/media/services-nav.100c73c25331ca4fb474da534ddfbe97.svg";
export { ForwardRef as ReactComponent };